import React from "react";
import { Radio } from "antd";
import { savedInRadioValues } from "../../../../publicDictionaryValues";
import ApprovedSavedIn from "../../../procedureFileSections/fields/savedInFields/approvedSavedIn";
import styles from "../../../procedureFileSections/fields/savedInFields/index.module.scss";
import applyJbSavedInStyles from "../../index.module.scss";

export default class ApplyJbSavedIn extends ApprovedSavedIn {
  render() {
    const { savedInRadioValue } = this.state.savedInSectionState;

    return (
      <div className={styles.procedureFileTop}>
        <div className={applyJbSavedInStyles.procedureSavedIn} style={{ borderColor: "#b3b3b3" }}>
          <div>
            <div className={styles.savedInTop} data-highlight-id="ProcedureSavedInType2">
              <div className={styles.procedureSaveInLabel}>Procedure Saved In:</div>
              <div className={styles.procedureSaveInChoice}>
                <Radio.Group
                  value={savedInRadioValue}
                  disabled={true}
                  data-testid="apply-jb-saved-in-radio-group"
                >
                  <Radio
                    value={savedInRadioValues.systemOnly}
                    data-testid="apply-jb-saved-in-system-only"
                  >
                    PMP System Only
                  </Radio>
                  <Radio
                    value={savedInRadioValues.systemAndClientServer}
                    data-testid="apply-jb-saved-in-system-and-server"
                  >
                    PMP System & Client Server
                  </Radio>
                  <Radio
                    value={savedInRadioValues.serverOnly}
                    data-testid="apply-jb-saved-in-server-only"
                  >
                    Client Server Only
                  </Radio>
                </Radio.Group>
              </div>
              {this.props.saveInTag}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
